export default __webpack_public_path__ + "static/media/DangerWhite.1b7b727c.svg";